import YesNoDialog from './../../../zzl-vue-component/YesNoDialog'
import TextareaAutosize from './../../../zzl-vue-component/TextareaAutosize'
import MenuItemList from './../../api/MenuItemList'
import { hankakuLower } from './../../../zzl-lib/Zenkaku'

const MAX_RESULTS = 5
const SEARCH_DELAY = 150

export default {
	props: {
		value: {
			type: Object
		},
		title: {
			type: String,
			default: 'リンク設定',
		}
	},
	data() {
		const intern = Object.assign({
			cms: true,
			itemId: null,
			title: '',
			url: '',
			newWindow: false,
			fileType: null,
		}, this.value)

		delete intern.id

		return {
			intern,
			query: '',
			queryTimer: null,
			items: [],
			matchedItems: [],
		}
	},
	components: {
		TextareaAutosize,
		YesNoDialog,
	},
	template: `
		<YesNoDialog
			:title="title"
			yes-label="OK"
			no-label="キャンセル"
			@yes="commit"
			@no="$emit('cancel')"
		>
			<div class="segcon">
				<div class="segcon-item" :class="{active: intern.cms}"
					@click="intern.cms = true"
				>
					既存のページ・ファイルから選択
				</div>
				<div class="segcon-item" :class="{active: !intern.cms}"
					@click="intern.cms = false"
				>
					タイトルとURLを指定
				</div>
			</div>
			<template v-if="intern.cms">
				<template v-if="intern.itemId">
					<div class="link-dialog-selected-page">
						<h4 class="title">{{intern.title}}</h4>
						<div class="url">{{ readableURL(intern.url) }}</div>
						<TextareaAutosize
							v-model="intern.description"
							class="index-section-input index-section-input-block description"
							placeholder="説明を追加..."
						/>
					</div>
					<button type="button" class="btn btn-sm btn-default" @click="reset">変更</button>
				</template>
				<template v-else>
					<input type="text" class="form-control" placeholder="タイトル・URLから検索"
						v-model="query"
						ref="queryInput"
					/>
					<span v-if="emptyQuery" class="label label-default">最近更新したページ</span>
					<div class="list-group">
						<div type="button" class="list-group-item index-editor-search-result-item"
							v-for="item in matchedItems" :key="item.id"
							@click="selectItem(item)"
						>
							{{item.title}}
							<span class="small text-muted">{{ readableURL(item.url) }}</span>
						</div>
					</div>
				</template>
			</template>
			<template v-if="!intern.cms">
				<div class="bs-ed-form-group">
					<div class="bs-ed-form-label">
						タイトル
					</div>
					<div class="bs-ed-form-controls">
						<input type="text" class="bs-ed-input"
							v-model="intern.title"
							ref="titleInput"
						/>
					</div>
				</div>
				<div class="bs-ed-form-group">
					<div class="bs-ed-form-label">
						URL
					</div>
					<div class="bs-ed-form-controls">
						<input type="text" v-model="intern.url" class="bs-ed-input">
						<label class="bs-ed-checkbox">
							<input type="checkbox" v-model="intern.newWindow"> 新しいウィンドウで開く
						</label>
					</div>
				</div>
				<div class="bs-ed-form-group">
					<div class="bs-ed-form-label">
						説明
					</div>
					<div class="bs-ed-form-controls">
						<textarea v-model="intern.description" class="bs-ed-input"></textarea>
					</div>
				</div>
			</template>
		</YesNoDialog>
	`,
	mounted() {
		this.resetFocus()
		MenuItemList.get().then(items => {
			this.items = items
			this.search()
		})
	},
	beforeDestroy() {
		clearTimeout(this.queryTimer)
	},
	computed: {
		emptyQuery() {
			return this.query.trim() === ''
		}
	},
	methods: {
		readableURL (url) {
			return url.replace(/\{uploads\}.*/, '[ファイル]')
		},
		commit() {
			// Convert to plain object
			const intern = JSON.parse(JSON.stringify(this.intern))
			this.$emit('commit', intern)
		},
		search() {
			const { query } = this

			if (this.emptyQuery) {
				this.matchedItems = this.items.slice(0, MAX_RESULTS)
			} else {
				const nQueries = hankakuLower(this.query).split(/\s/)
				this.matchedItems = this.items
					.map(item => {
						const score = nQueries.map(q => {
							if (q === item.url) return 3
							const i = hankakuLower(item.title).indexOf(q)
							const j = hankakuLower(item.url).indexOf(q)
							return ((i === 0) ? 2 : ((i > 0) ? 1 : 0)) + ((j === 0) ? 1 : ((j > 0) ? 1/2 : 0))
						}).reduce((sum, cur) => sum * cur, 1)
						return { item, score }
					})
					.filter(item => item.score > 0)
					.sort((x, y) => y.score - x.score)
					.map(itemScore => itemScore.item)
					.slice(0, MAX_RESULTS)
			}
		},
		selectItem(item) {
			this.intern.itemId = item.id
			this.intern.title = item.title
			this.intern.url = item.url
			this.intern.fileType = item.fileType || null
		},
		reset() {
			this.intern.itemId = null
			this.intern.title = ''
			this.intern.url = ''
			this.intern.fileType = null
			this.resetFocus()
		},
		resetFocus() {
			this.$nextTick(() => {
				const inputToFocus = (this.intern.cms) ? this.$refs.queryInput : this.$refs.titleInput
				if (inputToFocus) inputToFocus.focus()
			})
		},
	},
	watch: {
		query() {
			clearTimeout(this.queryTimer)
			this.queryTimer = setTimeout(() => this.search(), SEARCH_DELAY)
		},
		['intern.cms']() {
			this.resetFocus()
		},
	}
}
